import {
  IOrderManagementState,
  setIsCentralAdmin,
  setIsOrderSearchActive,
  setIsUserPopupModalActive,
  setOrderModule,
} from "@/app_redux/reducers/slices/auth/order_management_slice";
import { ROUTES } from "@/app/routes";
import { Tooltip } from "react-tooltip";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import { FiPhoneCall, FiFileText } from "react-icons/fi";
import { GrFormFilter } from "react-icons/gr";
import OMSAnalytics from "../../OMSAnalytics";
import { MdInfoOutline } from "react-icons/md";
import { useUtils } from "@/app/hooks/useUtils";
import { useLoader } from "@/app/hooks/useLoader";
import OrderStatus from "../../OrderStatusButton";
import StatsComponent from "../../StatsComponent";
import { useRouter } from "@/app/hooks/useRouter";
import SwitchComponent from "../../SwicthComponent";
import SearchComponent from "../../SearchComponent";
import FilterComponent from "../../FilterComponent";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useForm, useWatch } from "react-hook-form";
import ViewRefundDetails from "../ViewRefundDetails";
import RBACFlag from "@/app/components/core/RBACFlag";
import ViewPartialDetails from "../ViewPartialDetails";
import TabSwitchComponent from "../../TabSwitchComponent";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { useEffect, useMemo, useRef, useState } from "react";
import OrderActionButton from "../../OrderStatusActionButton";
import ClipboardComponent from "@/app/components/ui/Clipboard";
import PaginationComponent from "@/app/components/ui/Pagination";
import { useImageConstants } from "@/app/hooks/useImageConstants";
import ProductItemImage from "../../ModalComponent/ProductItemImage";
import NoDataFoundComponent from "@/app/components/ui/NoRecordFound";
import AnalyticsSwicthComponent from "../../AnalyticsSwicthComponent";
import TableSkeleton from "@/app/components/ui/Skeletons/TableSkeleton";
import OrderTrailsComponent from "../../ModalComponent/OrderTrailsComponent";
import SearchableSelectMenu from "@/app/components/ui/SelectMenus/SearchableSelectMenu";
import { useOrderManagementOrderListAPI } from "@/app/hooks/api_hooks/orders/useOrderListAPI";
import { useRxOrderCallConnectAPI } from "@/app/hooks/api_hooks/orders/useRxOrderCallConnectAPI";
import { useRxViewUrlAPI } from "@/app/hooks/api_hooks/orders/useRxViewUrlAPI";
import {
  IOrderManagementFilterBody,
  IOrderManagementSearchFilterBody,
  IOrderManagementStatsFilterBody,
} from "@/api_framework/api_modals/Orders";
import { useOrderManagementStatsAPI } from "@/app/hooks/api_hooks/orders/useOrderStatsAPI";
import { useOrderManagementOrderListSearchAPI } from "@/app/hooks/api_hooks/orders/useOrderListSearchAPI";
import { useFeatureAccess } from "@/app/hooks/useFeatureAccess";

const PageSize = 20;

const CODLIST = [
  {
    title: "All",
    id: "0",
  },
  {
    title: "Partial Order",
    id: "1",
  },
  {
    title: "COD",
    id: "2",
  },
  {
    title: "Manual Allocation",
    id: "3",
  },
  {
    title: "Central Order",
    id: "4",
  },
  {
    title: "Clinic",
    id: "5",
  },
  {
    title: "Transfer Order",
    id: "6",
  },
];

const BREACHLIST = [
  {
    title: "Delivery Breach",
    id: "1",
  },
  {
    title: "Assignment Breach",
    id: "2",
  },
  {
    title: "Rider Idle",
    id: "3",
  },
];

const BREACHCLINICLIST = [
  {
    title: "Packing Breach",
    id: "1",
  },
];

const RIDERLIST = [
  {
    title: "Rider Assigned",
    id: "1",
  },
  {
    title: "Rider Not Assigned",
    id: "2",
  },
];

const COD_STATUS_MAP = {
  "1": "partial_order",
  "2": "cod",
  "3": "manual_allocation",
  "4": "central_order",
  "5": "clinic_order",
  "6": "transfer_order",
};

const BREACH_STATUS_MAP = {
  "1": "delivery_breach",
  "2": "assignment_breach",
  "3": "rider_idle",
};

const BREACH_CLINIC_STATUS_MAP = {
  "1": "packing_breach",
};

const RIDER_STATUS_MAP = {
  "1": "rider_assigned",
  "2": "rider_not_assigned",
};

export interface IQCFilterInterface {
  orderStatus: Array<string>;
  codStatus: string;
  rxCallDetails: string;
  breach: string;
  rider: string;
}

const RX_CALL_DETAILS_FILTER_OPTIONS = [
  { id: "0", title: "All" },
  { id: "1", title: "Customer Tried" },
  { id: "2", title: "Total Attempts 0" },
  { id: "3", title: "Total Attempts 1" },
  { id: "4", title: "Total Attempts 2" },
  { id: "5", title: "Total Attempts >3" },
];

const DEFAULT_QC_FILTER_VALUES: IQCFilterInterface = {
  codStatus: "0",
  orderStatus: [],
  rxCallDetails: "0",
  breach: "0",
  rider: "0",
};

const CentralOrderComponent = () => {
  const { getRouteKey } = useRouter();
  const routeId = getRouteKey("ORDER_MANAGEMENT", "id");
  const { routeState } = useRouteInfo(routeId);
  const dispatch = useDispatch();
  const { veticDateFormat, truncateString, maskMobile } = useUtils();
  const { NO_PWL_RESULTS } = useImageConstants();
  const isOrderListInProgress = useLoader("isQcOrderListLoadingInProgress");
  const [_isMenuVisible, setIsMenuVisible] = useState(false);
  const { orderList, orderModule, isCentralAdmin, totalOrders, orderFilter, isOrderSearchActive } =
    routeState.state as IOrderManagementState;
  const userPermissions = useAppSelector((state) => state.auth?.userPermissions);
  const [active, setActive] = useState("3");
  const [currentPage, setCurrentPage] = useState(1);
  const [isChecked, setIsChecked] = useState(false);
  const [ordertrails, setOrdertrails] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const hasAppliedPhoneSearchRef = useRef(false);
  const [orderType, setOrderType] = useState<"QC" | "TRANSFER" | "Rx">("QC");
  const isRxOrders = orderType === "Rx";
  // RBAC: ORDER_CENTRAL_MODULE_ACCESS — legacy roles: super_admin, central_ops, Tele_Doctor
  const isCentralOpsUser = useFeatureAccess("ORDER_CENTRAL_MODULE_ACCESS");
  // RBAC: ORDER_HIDE_DROP_OTP — legacy roles: clinic_ops, clinic_ops_doggyworld
  const hideDropOtp = useFeatureAccess("ORDER_HIDE_DROP_OTP");
  // RBAC: ORDER_MODULE_CLINIC_USER — legacy roles: clinic_ops, clinic_ops_doggyworld
  const isClinicModuleUser = useFeatureAccess("ORDER_MODULE_CLINIC_USER");
  const userAllowedActions = userPermissions?.role_permission?.actions || [];
  const canAccessQcTransferOrders =
    userAllowedActions.length === 0 || userAllowedActions.includes("QC_TRANSFER_ORDERS");
  const canAccessRxOrders = userAllowedActions.length === 0 || userAllowedActions.includes("RX_ORDERS");
  const showNonRxOrderColumns = canAccessQcTransferOrders && (orderType === "QC" || orderType === "TRANSFER");
  const fetchOrderListAPI = useOrderManagementOrderListAPI();
  const fetchStatsAPI = useOrderManagementStatsAPI();
  const connectRxCallAPI = useRxOrderCallConnectAPI();
  const getRxViewUrlAPI = useRxViewUrlAPI();
  const [rxUploadInProgressMap, setRxUploadInProgressMap] = useState<Record<string, boolean>>({});
  const oauthUser = useAppSelector((state) => state.auth?.user);
  const userLoginInfo = useAppSelector((state) => state.auth?.userLoginInfo);
  const [rxCallCooldownMap, setRxCallCooldownMap] = useState<Record<string, boolean>>({});
  const rxCallCooldownTimersRef = useRef<Record<string, ReturnType<typeof setTimeout>>>({});
  const isInitialRender = useRef(true);
  const formatSubOrderId = (subOrderId?: string | null) => (subOrderId?.trim() ? subOrderId : "NA");
  const formatClinicName = (clinicName?: string | null) => (clinicName?.trim() ? clinicName : "NA");
  const hasClinicName = (clinicName?: string | null) => Boolean(clinicName?.trim());
  const isResettingFilters = useRef(false);
  const isTabClick = useRef(false);
  const skipNextFilterEffect = useRef(false);
  const fetchSearchOrderListAPI = useOrderManagementOrderListSearchAPI();

  const formHook = useForm<IQCFilterInterface>({
    mode: "onChange",
    defaultValues: DEFAULT_QC_FILTER_VALUES,
  });
  //test
  const { control } = formHook;
  const codStatus = useWatch({ control, name: "codStatus" });
  const orderStatus = useWatch({ control, name: "orderStatus" });
  const breach = useWatch({ control, name: "breach" });
  const rider = useWatch({ control, name: "rider" });
  const rxCallDetails = useWatch({ control, name: "rxCallDetails" });
  const [searchText, setSearchText] = useState("");
  const order_source = orderType === "TRANSFER" ? "TO" : "QC";

  const currentTableData = useMemo(() => {
    return Array.isArray(orderList) ? orderList.filter(Boolean) : [];
  }, [orderList]);

  const qcSuborderFilterList = useMemo(() => {
    if (orderType === "QC") {
      return CODLIST.filter((item) => item.id !== "6");
    }
    return CODLIST;
  }, [orderType]);

  const getOrderSource = (selectedOrderType: "QC" | "TRANSFER" | "Rx" = orderType) => {
    if (!isCentralOpsUser) return undefined;
    return selectedOrderType === "TRANSFER" ? "TO" : "QC";
  };

  const getStatusFilter = (selectedOrderType: "QC" | "TRANSFER" | "Rx" = orderType, selectedActive = active) => {
    if (selectedOrderType === "Rx") {
      return "rx_pending";
    }
    switch (selectedActive) {
      case "1":
        return "payment_due";
      case "2":
        return "pending";
      case "3":
        return "confirmed";
      case "4":
        return "ready_for_pickup";
      case "5":
        return "picked";
      case "6":
        return ["return_in_transit", "return_initiated", "undelivered_in_transit"].join(",");
      case "7":
        return "delivered";
      case "8":
        return "undelivered";
      case "9":
        return "cancelled";
      case "10":
        return "returned";
      default:
        return "";
    }
  };

  const getFilters = (overrides: Partial<IQCFilterInterface> = {}) => {
    const values = formHook.getValues();
    return {
      codStatus: overrides.codStatus ?? values.codStatus,
      breach: overrides.breach ?? values.breach,
      rider: overrides.rider ?? values.rider,
      orderStatus: overrides.orderStatus ?? values.orderStatus,
      rxCallDetails: overrides.rxCallDetails ?? values.rxCallDetails,
    };
  };

  const getMappedFilters = (filtersFromForm = getFilters()) => ({
    breach_tag:
      filtersFromForm.breach !== "0"
        ? isClinicModule
          ? BREACH_CLINIC_STATUS_MAP[filtersFromForm.breach]
          : BREACH_STATUS_MAP[filtersFromForm.breach]
        : undefined,
    rider_status: filtersFromForm.rider !== "0" ? RIDER_STATUS_MAP[filtersFromForm.rider] : undefined,
    order_type: filtersFromForm.codStatus !== "0" ? COD_STATUS_MAP[filtersFromForm.codStatus] : undefined,
  });

  const buildOrderListPayload = (
    pageNumber: number,
    selectedOrderType: "QC" | "TRANSFER" | "Rx" = orderType,
    selectedActive = active,
    filterOverrides: Partial<IQCFilterInterface> = {},
  ): IOrderManagementFilterBody => ({
    clinic_id: orderFilter?.clinic_id?.split(","),
    start_date: orderFilter?.start_date,
    end_date: orderFilter?.end_date,
    order_status: getStatusFilter(selectedOrderType, selectedActive),
    order_source: getOrderSource(selectedOrderType),
    source: selectedOrderType === "Rx" ? "CENTRAL" : orderModule,
    page_number: pageNumber,
    page_size: PageSize,
    filters: getMappedFilters(getFilters(filterOverrides)),
  });

  const buildSearchPayload = (
    pageNumber: number,
    searchValue: string,
    selectedOrderType: "QC" | "TRANSFER" | "Rx" = orderType,
    filterOverrides: Partial<IQCFilterInterface> = {},
  ): IOrderManagementSearchFilterBody => ({
    clinic_id: orderFilter?.clinic_id?.split(","),
    start_date: orderFilter?.start_date,
    end_date: orderFilter?.end_date,
    order_source: getOrderSource(selectedOrderType),
    source: selectedOrderType === "Rx" ? "CENTRAL" : orderModule,
    page_number: pageNumber,
    page_size: PageSize,
    search: searchValue,
    filters: getMappedFilters(getFilters(filterOverrides)),
  });

  const fetchOrdersForPage = (
    pageNumber: number,
    selectedOrderType: "QC" | "TRANSFER" | "Rx" = orderType,
    selectedActive = active,
    filterOverrides: Partial<IQCFilterInterface> = {},
  ) => {
    if (!orderFilter?.clinic_id || !orderFilter?.start_date) return;
    const trimmedSearch = searchText.trim();
    if (isOrderSearchActive && trimmedSearch) {
      fetchSearchOrderListAPI(buildSearchPayload(pageNumber, trimmedSearch, selectedOrderType, filterOverrides));
      return;
    }
    fetchOrderListAPI(buildOrderListPayload(pageNumber, selectedOrderType, selectedActive, filterOverrides));
  };

  const fetchOrdersUnified = (
    page = 1,
    searchValue = searchText,
    selectedOrderType: "QC" | "TRANSFER" | "Rx" = orderType,
    filterOverrides: Partial<IQCFilterInterface> = {},
  ) => {
    if (!orderFilter?.clinic_id || !orderFilter?.start_date) return;
    const trimmedSearch = searchValue.trim();
    if (trimmedSearch) {
      fetchSearchOrderListAPI(buildSearchPayload(page, trimmedSearch, selectedOrderType, filterOverrides));
      return;
    }
    fetchOrderListAPI(buildOrderListPayload(page, selectedOrderType, active, filterOverrides));
  };

  const applyImmediateFilterChange = (
    field: "codStatus" | "breach" | "rider",
    value: string,
    options?: { shouldTouch?: boolean; shouldValidate?: boolean; shouldDirty?: boolean },
  ) => {
    const currentValue = formHook.getValues(field);
    if (currentValue === value) {
      setIsMenuVisible(false);
      return;
    }

    skipNextFilterEffect.current = true;
    formHook.setValue(field, value, {
      shouldDirty: options?.shouldDirty ?? true,
      shouldTouch: options?.shouldTouch ?? true,
      shouldValidate: options?.shouldValidate ?? true,
    });
    setCurrentPage(1);
    fetchOrdersUnified(1, searchText, orderType, { [field]: value });
    setIsMenuVisible(false);
  };

  const handleOrderTypeChange = (nextOrderType: "QC" | "TRANSFER" | "Rx") => {
    const defaultActive = nextOrderType === "Rx" ? "0" : "3";
    setOrderType(nextOrderType);
    setActive(defaultActive);
    setCurrentPage(1);
    dispatch(setIsOrderSearchActive(false));
    dispatch(setIsUserPopupModalActive(false));
    if (!orderFilter?.clinic_id || !orderFilter?.start_date) return;
    if (nextOrderType === "Rx") return;
    fetchOrdersForPage(1, nextOrderType, defaultActive);
    const statsBody: IOrderManagementStatsFilterBody = {
      start_date: orderFilter?.start_date,
      end_date: orderFilter?.end_date,
      clinic_id: orderFilter?.clinic_id?.split(","),
      order_source: getOrderSource(nextOrderType),
    };
    fetchStatsAPI(statsBody);
  };

  const resetAllFilters = () => {
    isResettingFilters.current = true;
    formHook.reset(DEFAULT_QC_FILTER_VALUES);
    setTimeout(() => {
      isResettingFilters.current = false;
    }, 0);
  };

  const clearSearchState = () => {
    setSearchText("");
    dispatch(setIsUserPopupModalActive(false));
  };

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    if (skipNextFilterEffect.current) {
      skipNextFilterEffect.current = false;
      return;
    }
    if (isResettingFilters.current) {
      isTabClick.current = false;
      return;
    }
    if (isTabClick.current) {
      isTabClick.current = false;
      return;
    }
    const timer = setTimeout(() => {
      setCurrentPage(1);
      fetchOrdersUnified(1);
    }, 300);
    return () => clearTimeout(timer);
  }, [JSON.stringify(orderStatus), isOrderSearchActive]);

  useEffect(() => {
    if (orderType !== "Rx") return;
    setCurrentPage(1);
    fetchOrdersForPage(1, "Rx", "0");
  }, [orderType, orderFilter?.clinic_id, orderFilter?.start_date, orderFilter?.end_date, isOrderSearchActive]);

  // Auto-search a user's orders when redirected with a phone_number in the URL (e.g. from Exotel talking points)
  useEffect(() => {
    if (hasAppliedPhoneSearchRef.current) return;
    const phoneFromUrl = (new URLSearchParams(location.search).get("phone_number") ?? "").trim();
    if (!phoneFromUrl) return;
    if (!orderFilter?.clinic_id || !orderFilter?.start_date) return;
    hasAppliedPhoneSearchRef.current = true;
    setSearchText(phoneFromUrl);
    dispatch(setIsOrderSearchActive(true));
    dispatch(setIsUserPopupModalActive(true));
    setActive("0");
    setCurrentPage(1);
    fetchOrdersUnified(1, phoneFromUrl);
  }, [location.search, orderFilter?.clinic_id, orderFilter?.start_date]);

  useEffect(() => {
    if (!isCentralOpsUser) return;
    if (orderType === "Rx" && !canAccessRxOrders) {
      if (canAccessQcTransferOrders) {
        setOrderType("QC");
      }
      return;
    }
    if ((orderType === "QC" || orderType === "TRANSFER") && !canAccessQcTransferOrders) {
      if (canAccessRxOrders) {
        setOrderType("Rx");
      }
    }
  }, [orderType, canAccessRxOrders, canAccessQcTransferOrders, isCentralOpsUser]);

  useEffect(() => {
    if (isRxOrders && orderModule !== "CENTRAL") {
      dispatch(setOrderModule("CENTRAL"));
    }
  }, [isRxOrders, orderModule, dispatch]);

  useEffect(() => {
    if (userPermissions) {
      let isAdmin = false;
      let isUser = false;
      if (isClinicModuleUser) {
        isUser = true;
      } else {
        isAdmin = true;
      }
      if (isAdmin && isUser) {
        dispatch(setOrderModule("CENTRAL"));
        dispatch(setIsCentralAdmin(true));
      } else if (isAdmin) {
        dispatch(setOrderModule("CENTRAL"));
        dispatch(setIsCentralAdmin(true));
      } else if (isUser) {
        dispatch(setOrderModule("CLINIC"));
        dispatch(setIsCentralAdmin(false));
      } else {
        dispatch(setOrderModule(""));
      }
    }
  }, [userPermissions]);

  const convertStringToDate = (date, item) => {
    if (!date) {
      return item === "time" ? "05:30 AM" : "--/--/--";
    }
    const dtObj = new Date(date);
    if (Number.isNaN(dtObj?.getTime())) {
      return item === "time" ? "05:30 AM" : "--/--/--";
    }
    const dateDdMmYy = dtObj?.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });
    const time = dtObj?.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
    if (item === "date") {
      return dateDdMmYy;
    } else {
      return time;
    }
  };

  const toTitleCase = (value: string) =>
    value
      ?.split("_")
      ?.map((word) => word?.charAt(0)?.toUpperCase() + word?.slice(1))
      ?.join(" ");

  const getSlaTags = (tags: unknown): string[] => {
    if (!tags) return [];
    if (Array.isArray(tags)) {
      return tags.map((tag) => String(tag).trim()).filter(Boolean);
    }
    if (typeof tags === "string") {
      return tags
        .split(/[|,]/)
        .map((tag) => tag.trim())
        .filter(Boolean);
    }
    return [];
  };

  const getSlaTagClass = (tag: string) => {
    const normalizedTag = tag?.toLowerCase();
    if (normalizedTag.includes("assignment") && normalizedTag.includes("breach")) {
      return "bg-[#FEF3F2] text-[#B42318] ring-[#FDA29B]";
    }
    if (normalizedTag.includes("pickup") && normalizedTag.includes("breach")) {
      return "bg-[#FFF7ED] text-[#B54708] ring-[#FEC84B]";
    }
    if (normalizedTag.includes("delivery") && normalizedTag.includes("breach")) {
      return "bg-[#FEF3F2] text-[#B42318] ring-[#FDA29B]";
    }
    return "bg-[#F3F4F6] text-[#374151] ring-[#D1D5DB]";
  };

  const renderOrderMetaBadges = (order: any) => (
    <>
      {order?.order_details?.is_central_order === true && (
        <span className="inline-flex rounded-full bg-[#DBEAFE] px-2 py-0.5 text-[11px] font-semibold text-[#1D4ED8]">
          Central
        </span>
      )}
      {order?.source === "C2C" && (
        <span className="inline-flex rounded-full bg-[#D1FAE5] px-2 py-0.5 text-[11px] font-semibold text-[#065F46]">
          Transfer
        </span>
      )}
      {order?.source === "clinic" && (
        <span className="inline-flex rounded-full bg-[#E5E7EB] px-2 py-0.5 text-[11px] font-semibold text-[#111827]">
          Clinic
        </span>
      )}
      {order?.source === "home_service" && (
        <span className="inline-flex whitespace-nowrap rounded-full bg-[#FCE7F3] px-2 py-0.5 text-[11px] font-semibold text-[#9D174D]">
          Home Service
        </span>
      )}
      {order?.order_details?.payment_method_id === 1 && (
        <span className="inline-flex rounded-full bg-[#FFF3CD] px-2 py-0.5 text-[11px] font-semibold text-[#92400E]">
          COD
        </span>
      )}
      {order?.order_details?.is_partial_handling_needed === true && (
        <span
          className={`inline-flex rounded-full px-2 py-0.5 text-[11px] font-semibold ${order?.order_details?.is_partial_processed ? "bg-[#DCFCE7] text-[#166534]" : "bg-[#FEE2E2] text-[#991B1B]"
            }`}
        >
          {order?.order_details?.is_partial_processed ? "Partial Success" : "Partial Failed"}
        </span>
      )}
      {order?.order_details?.is_manual_allocation === true && (
        <span className="inline-flex rounded-full bg-[#F3E8FF] px-2 py-0.5 text-[11px] font-semibold text-[#6B21A8]">
          Manual
        </span>
      )}
    </>
  );

  const visitCustomerProfile = (userId: string) => {
    if (orderModule === "CENTRAL") {
      navigate(
        `${ROUTES.ROOT.children.CUSTOMER_PROFILE.children.DETAILS_CUSTOMER.url}/edit-customer/${userId}?from_om=true`,
      );
    }
  };

  const normalizePhoneNumber = (value?: string | number | null) => {
    if (!value) return "";
    const trimmed = String(value).trim();
    if (!trimmed) return "";
    if (trimmed.startsWith("+")) return trimmed;
    const digitsOnly = trimmed.replace(/\D/g, "");
    if (digitsOnly.length === 10) return `+91${digitsOnly}`;
    if (digitsOnly.length > 0) return `+${digitsOnly}`;
    return "";
  };

  const getFromNumber = () => normalizePhoneNumber(oauthUser?.mobile ?? userLoginInfo?.mobile ?? null);

  const isRxCallAllowed = (order: any) => {
    const prescriptionStatus = String(order?.prescription_status ?? "").toLowerCase();
    return prescriptionStatus === "required";
  };

  const getConsultationNumber = (order: any) =>
    order?.consultation_number ??
    order?.order_details?.consultation_number ??
    order?.client_details?.consultation_number;

  const getRxCallToNumber = (order: any) => {
    const consultationNumber = getConsultationNumber(order);
    if (consultationNumber) return consultationNumber;
    return order?.client_details?.mobile ?? null;
  };

  const getRxCallCooldownKey = (order: any) => {
    const orderId = order?.order_details?.order_id ?? order?.order_id;
    const toNumber = getRxCallToNumber(order);
    return String(orderId ?? toNumber ?? "");
  };

  const clearRxCallCooldown = (key: string) => {
    const existingTimer = rxCallCooldownTimersRef.current[key];
    if (existingTimer) {
      clearTimeout(existingTimer);
      delete rxCallCooldownTimersRef.current[key];
    }
    setRxCallCooldownMap((prev) => {
      if (!prev[key]) return prev;
      const next = { ...prev };
      delete next[key];
      return next;
    });
  };

  const startRxCallCooldown = (key: string) => {
    if (!key) return;
    clearRxCallCooldown(key);
    setRxCallCooldownMap((prev) => ({ ...prev, [key]: true }));
    rxCallCooldownTimersRef.current[key] = setTimeout(() => {
      clearRxCallCooldown(key);
    }, 7000);
  };

  const handleRxClientCall = async (order: any) => {
    if (!isRxCallAllowed(order)) return;
    const cooldownKey = getRxCallCooldownKey(order);
    if (!cooldownKey || rxCallCooldownMap[cooldownKey]) return;
    startRxCallCooldown(cooldownKey);
    const fromNumber = getFromNumber();
    const toNumber = normalizePhoneNumber(getRxCallToNumber(order));
    const orderId = order?.order_details?.order_id ?? order?.order_id;
    const response = await connectRxCallAPI({
      from_number: fromNumber || null,
      to_number: toNumber || null,
      record: true,
      status_callback_content_type: "application/json",
      status_callback_events: ["terminal", "answered"],
      order_id: orderId || null,
    });
    if (response?.status) {
      fetchOrdersForPage(currentPage);
      return;
    }
    clearRxCallCooldown(cooldownKey);
  };

  const handleViewUploadedPrescription = async (order: any) => {
    const orderId = order?.order_details?.sub_order_id || order?.order_details?.order_id;
    if (!orderId) return;

    const userRxKey = order?.order_details?.user_rx_key || order?.user_rx_key;
    const customerUserId = order?.client_details?.user_id;

    if (!userRxKey || !customerUserId) {
      return;
    }

    setRxUploadInProgressMap((prev) => ({ ...prev, [orderId]: true }));
    try {
      const response = await getRxViewUrlAPI({
        user_rx_key: userRxKey,
        customer_user_id: customerUserId,
      });

      if (response?.status && response?.data?.view_url) {
        window.open(response.data.view_url, "_blank");
      }
    } catch (error) {
      console.error("Upload RX error:", error);
    } finally {
      setRxUploadInProgressMap((prev) => ({ ...prev, [orderId]: false }));
    }
  };

  const renderRxCallButton = (order: any) => {
    if (!isRxOrders || !getFromNumber() || !getRxCallToNumber(order) || !isRxCallAllowed(order)) return null;
    return (
      <button
        type="button"
        aria-label="Connect call"
        disabled={rxCallCooldownMap[getRxCallCooldownKey(order)]}
        className="inline-flex h-6 w-6 items-center justify-center rounded-full border border-[#D0D5DD] text-[#0B6EFF] transition-colors duration-150 hover:bg-[#EEF4FF] disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-transparent"
        onClick={() => handleRxClientCall(order)}
      >
        <FiPhoneCall className="h-3.5 w-3.5" />
      </button>
    );
  };

  useEffect(() => {
    return () => {
      Object.values(rxCallCooldownTimersRef.current).forEach((timer) => clearTimeout(timer));
      rxCallCooldownTimersRef.current = {};
    };
  }, []);

  const getRxCallDetailValue = (order: any, keys: string[]) => {
    const callDetails = order?.call_details || {};
    for (const key of keys) {
      const value = callDetails?.[key] ?? order?.[key] ?? order?.client_details?.[key] ?? order?.order_details?.[key];
      if (value !== undefined && value !== null && value !== "") {
        return value;
      }
    }
    return null;
  };

  const formatRxLastTriedAt = (rawValue: unknown) => {
    if (rawValue === null || rawValue === undefined || rawValue === "") return "NA";
    if (typeof rawValue === "number") {
      return veticDateFormat(rawValue) || "NA";
    }
    const normalized = String(rawValue)
      .trim()
      .replace(" ", "T")
      .replace(/(\.\d{3})\d+/, "$1");
    const parsedDate = new Date(normalized);
    if (!Number.isNaN(parsedDate.getTime())) {
      return veticDateFormat(Math.floor(parsedDate.getTime() / 1000)) || "NA";
    }
    return veticDateFormat(rawValue as any) || "NA";
  };

  const toBooleanFlag = (value: unknown): boolean => {
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      return normalized === "true" || normalized === "1" || normalized === "yes";
    }
    return false;
  };

  const getRxCallDetails = (order: any) => {
    const lastTriedRaw = getRxCallDetailValue(order, ["last_tried_at"]);
    const doctorTriedRaw = getRxCallDetailValue(order, ["doctor_tried_to_connect"]);
    const customerTriedRaw = getRxCallDetailValue(order, ["user_tried_to_connect", "customer_tried"]);
    return {
      lastTriedAt: formatRxLastTriedAt(lastTriedRaw),
      doctorTriedToConnect: doctorTriedRaw ?? "0",
      customer_tried: toBooleanFlag(customerTriedRaw),
    };
  };

  const baseData = useMemo(() => {
    return Array.isArray(orderList) ? orderList.filter(Boolean) : [];
  }, [orderType, orderList]);

  useEffect(() => {
    formHook.reset(DEFAULT_QC_FILTER_VALUES);
    setCurrentPage(1);
  }, [orderType, orderModule]);

  const isCentralModule = orderModule === "CENTRAL";
  const isClinicModule = orderModule === "CLINIC";
  const headerClass =
    "p-2 py-3 text-left text-xs whitespace-nowrap font-medium text-black tracking-wider sticky top-0 z-[30] bg-[#F5F5F5]";
  const actionStickyHeaderClass =
    "sm:sticky right-0 z-[35] bg-gray-100 sm:shadow-[-4px_0_10px_-8px_rgba(15,23,42,0.22)]";
  const cellClass = `p-2 text-xs font-normal text-black ${isCentralModule ? "align-middle" : "align-top"}`;
  const actionStickyCellClass =
    "sm:sticky right-0 z-[15] bg-gray-50 sm:shadow-[-4px_0_10px_-8px_rgba(15,23,42,0.22)]";
  const hasBackendData = Array.isArray(baseData) && baseData.length > 0;
  const hasVisibleRows = Array.isArray(currentTableData) && currentTableData.length > 0;
  const isHeaderFilterEmptyState = hasBackendData && !hasVisibleRows;
  const showDeliveryAddressColumn = isCentralModule && (showNonRxOrderColumns || isRxOrders);
  const emptyStateColSpan = (() => {
    if (isRxOrders) return isCentralModule ? 7 : 5;
    return isCentralModule ? 10 : 7;
  })();

  return (
    <div className="rounded-lg bg-white p-2">
      <div className="flex flex-wrap items-center justify-between gap-2 pb-1">
        <RBACFlag actionId="TAB_SWITCH_BUTTON">
          <TabSwitchComponent
            orderType={orderType}
            setOrderType={handleOrderTypeChange}
            showQcTransferOrdersTabs={canAccessQcTransferOrders}
            showRxOrdersTab={canAccessRxOrders}
          />
        </RBACFlag>
        <div className="flex items-center justify-end gap-2">
          {showNonRxOrderColumns && (
            <>
              <AnalyticsSwicthComponent isChecked={isChecked} setIsChecked={setIsChecked} />
              <span className="text-gray-400">|</span>
            </>
          )}
          {isCentralAdmin && showNonRxOrderColumns && <SwitchComponent />}
        </div>
      </div>
      {showNonRxOrderColumns &&
        (isChecked ? (
          <OMSAnalytics />
        ) : (
          <StatsComponent
            active={active}
            setActive={setActive}
            orderType={orderType}
            resetPage={() => setCurrentPage(1)}
            resetAllFilters={resetAllFilters}
            clearSearchState={clearSearchState}
            isTabClick={isTabClick}
          />
        ))}
      <div className="my-2 flex flex-col gap-3 rounded-lg border border-[#EAECF0] bg-[#F9FAFB] p-3 lg:flex-row lg:items-end lg:justify-between">
        <SearchComponent
          setActive={setActive}
          orderType={orderType}
          searchText={searchText}
          setSearchText={setSearchText}
          onSearch={(text) => {
            setSearchText(text);
            setActive("0");
            fetchOrdersUnified(1, text);
          }}
          order_source={order_source}
        />
        <FilterComponent
          active={active}
          setActive={setActive}
          orderType={orderType}
          resetPage={() => setCurrentPage(1)}
        />
      </div>
      <div className="mt-1 flex justify-between">
        <p className="ml-2 mt-2 text-xs font-normal text-slate-400">
          Showing {totalOrders === 0 ? 0 : (currentPage - 1) * PageSize + 1} -{" "}
          {Math.min(currentPage * PageSize, totalOrders)} of {totalOrders} results
        </p>
      </div>
      {!isOrderListInProgress ? (
        <div className="rounded-md bg-white">
          {Array.isArray(currentTableData) ? (
            <>
              <div className="mt-3 space-y-3 md:hidden">
                {hasVisibleRows ? (
                  currentTableData?.map((order, id) => {
                    const slaTags = getSlaTags(order?.order_details?.sla_tags);
                    return (
                      <div key={id} className="group rounded-xl border border-gray-200 bg-white p-3 shadow-sm">
                        <div className="flex items-start justify-between gap-3">
                          <div className="min-w-0">
                            {isCentralModule && (
                              <p className="text-xs font-medium text-gray-900">
                                Order ID: {order?.order_details?.order_id}
                              </p>
                            )}
                            {showNonRxOrderColumns && (
                              <p className="mt-1 truncate text-sm font-semibold text-gray-900">
                                {formatSubOrderId(order?.order_details?.sub_order_id)}
                              </p>
                            )}
                            <p className="text-xs text-gray-500">{veticDateFormat(order?.created_at)}</p>
                          </div>
                          <div className="flex max-w-[55%] flex-wrap justify-end gap-1">
                            {renderOrderMetaBadges(order)}
                            {order?.source === "kuddle" && (
                              <span className="inline-flex rounded-full bg-[#0D9488] px-2 py-0.5 text-[11px] font-semibold text-white">
                                Kuddle
                              </span>
                            )}
                          </div>
                        </div>
                        {order?.order_details?.is_partial_handling_needed === true && isCentralModule && (
                          <div className="mt-2">
                            <ViewPartialDetails orders={order} />
                          </div>
                        )}
                        {isCentralModule && showNonRxOrderColumns && (
                          <div className="mt-3">
                            <p className="text-[11px] font-medium text-gray-500">Clinic</p>
                            <p className="text-sm text-gray-900">{formatClinicName(order?.clinic_details?.name)}</p>
                          </div>
                        )}
                        <div className="mt-3">
                          <p className="text-[11px] font-medium text-gray-500">Client Details</p>
                          <div className="flex items-center gap-2">
                            <p
                              onClick={() => {
                                if (order?.source !== "C2C") {
                                  visitCustomerProfile(order?.client_details?.user_id);
                                }
                              }}
                              data-tooltip-id="order_client_name"
                              data-tooltip-content={order?.client_details?.name}
                              className={`text-sm capitalize ${order?.source === "C2C" ? "text-gray-900" : "cursor-pointer text-[#0B6EFF]"}`}
                            >
                              {truncateString(order?.client_details?.name, 15)}
                            </p>
                            {renderRxCallButton(order)}
                          </div>
                          {isCentralModule && (
                            <p className="text-sm text-gray-900">
                              {maskMobile(String(order?.client_details?.mobile ?? "")) || "NA"}
                            </p>
                          )}
                          {slaTags?.length > 0 && (
                            <div className="mt-1 flex flex-wrap gap-1">
                              {slaTags?.map((tag) => (
                                <span
                                  key={`${order?.order_details?.sub_order_id}-${tag}`}
                                  className={`inline-flex w-fit whitespace-nowrap rounded-full px-2 py-0.5 text-[10px] font-semibold ring-1 ring-inset ${getSlaTagClass(tag)}`}
                                >
                                  {toTitleCase(tag)}
                                </span>
                              ))}
                            </div>
                          )}
                          {(order?.refund_details || order?.refund_history?.length > 0) && isCentralModule && (
                            <div className="mt-1">
                              <ViewRefundDetails orders={order} />
                            </div>
                          )}
                        </div>
                        {showDeliveryAddressColumn && (
                          <div className="mt-3">
                            <p className="text-[11px] font-medium text-gray-500">Delivery Address</p>
                            <div className="flex items-start gap-1 text-sm text-gray-900">
                              <span>{order?.client_details?.address_detail?.address_1}</span>
                              <ClipboardComponent
                                className="h-4 w-4"
                                copyId="order"
                                text={`latitude: ${order?.client_details?.address_detail?.latitude} longitude: ${order?.client_details?.address_detail?.longitude}`}
                              />
                            </div>
                            <p className="text-sm text-gray-900">{order?.client_details?.address_detail?.address_2}</p>
                          </div>
                        )}
                        <div className="mt-3">
                          <div className="flex items-center justify-between">
                            <p className="text-[11px] font-medium text-gray-500">Order Status</p>
                            {showNonRxOrderColumns && (
                              <span onClick={() => setOrdertrails(order?.delivery_trail)}>
                                <MdInfoOutline className="h-4 w-4 cursor-pointer text-gray-500 hover:text-gray-700" />
                              </span>
                            )}
                          </div>
                          <div className="mt-1 flex items-center gap-1">
                            <OrderStatus status={order?.order_details?.order_status} />
                            {(order?.order_details?.rx_uploaded || order?.rx_uploaded) && (
                              <button
                                type="button"
                                onClick={() => handleViewUploadedPrescription(order)}
                                disabled={rxUploadInProgressMap[order?.order_details?.sub_order_id || order?.order_details?.order_id]}
                                className="flex items-center gap-1 text-xs font-medium text-[#0B6EFF] hover:underline disabled:opacity-50 disabled:cursor-not-allowed ml-1"
                              >
                                <span>{rxUploadInProgressMap[order?.order_details?.sub_order_id || order?.order_details?.order_id] ? "Opening..." : "Uploaded RX"}</span>
                                <FiFileText className="h-3.5 w-3.5" />
                              </button>
                            )}
                          </div>
                        </div>
                        <div className="mt-3">
                          <p className="text-[11px] font-medium text-gray-500">Items</p>
                          {order?.order_details?.order_status === "confirmed" && orderModule === "CLINIC" ? null : (
                            <ol className="m-0 mt-1 space-y-1 p-0">
                              {order?.order_details?.sub_order_items?.map((item, itemId) => (
                                <li key={itemId} className="flex">
                                  <div className="flex w-full cursor-pointer break-words text-sm text-gray-900">
                                    {itemId + 1}.
                                    <span>
                                      <ProductItemImage value={item} data={order.order_details.sub_order_items} />
                                    </span>
                                  </div>
                                </li>
                              ))}
                            </ol>
                          )}
                        </div>
                        {showNonRxOrderColumns && (
                          <div className="mt-3 grid grid-cols-1 gap-3">
                            <div>
                              <p className="text-[11px] font-medium text-gray-500">Rider Details</p>
                              <div className="mt-1 rounded-lg bg-[#F9FAFB] p-2">
                                <p className="text-sm font-semibold text-gray-900">
                                  {order?.delivery_details?.rider_name}
                                </p>
                                <p className="text-sm text-gray-700">{order?.delivery_details?.rider_mobile}</p>
                                <p className="mt-1 text-xs text-gray-600">
                                  ETA: {convertStringToDate(order?.delivery_details?.expected_time, "time")}
                                </p>
                                {order?.order_details?.order_status !== "confirmed" &&
                                  order?.delivery_details?.tracking_link && (
                                    <p
                                      className="mt-1 inline-flex cursor-pointer rounded-full bg-[#EEF4FF] px-2 py-0.5 text-xs font-medium text-[#0B6EFF] hover:bg-[#DFEAFF]"
                                      onClick={() => window.open(order?.delivery_details?.tracking_link, "_blank")}
                                    >
                                      Tracking Link
                                    </p>
                                  )}
                                <div className="mt-2 flex flex-wrap gap-1">
                                  {order?.delivery_details?.drop_otp && !hideDropOtp && (
                                    <span className="rounded-full bg-[#F3F4F6] px-2 py-0.5 text-xs text-gray-700">
                                      Drop OTP: {order.delivery_details.drop_otp}
                                    </span>
                                  )}

                                  {order?.delivery_details?.pickup_otp &&
                                    order?.order_details?.order_status === "ready_for_pickup" && (
                                      <span className="rounded-full bg-[#F3F4F6] px-2 py-0.5 text-xs text-gray-700">
                                        Pickup OTP: {order?.delivery_details?.pickup_otp}
                                      </span>
                                    )}
                                  {order?.delivery_details?.rto_otp && (
                                    <span className="rounded-full bg-[#F3F4F6] px-2 py-0.5 text-xs text-gray-700">
                                      RTO OTP: {order?.delivery_details?.rto_otp}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div>
                              <p className="text-[11px] font-medium text-gray-500">Invoice</p>
                              {order?.order_details?.order_status === "confirmed" &&
                                orderModule === "CLINIC" ? null : order?.invoice_details?.length > 0 ? (
                                  <div className="mt-1 flex flex-col gap-1">
                                    {order?.invoice_details?.map((invoice, index) => (
                                      <a
                                        key={index}
                                        href={invoice?.invoice_link}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="flex items-center text-sm text-[#0B6EFF] hover:underline"
                                      >
                                        <span>{invoice?.file_name}</span>
                                        <img
                                          className="ml-2"
                                          src="https://vetic-img.s3.ap-south-1.amazonaws.com/website/admin-tool/invoiceIcon.svg"
                                          alt="invoice"
                                        />
                                      </a>
                                    ))}
                                  </div>
                                ) : (
                                <p className="text-sm text-gray-900">NA</p>
                              )}
                            </div>
                          </div>
                        )}
                        <div className="mt-3">
                          <OrderActionButton orders={order} module={orderModule} />
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <NoDataFoundComponent imageURL={NO_PWL_RESULTS} message="No Orders Found" />
                )}
              </div>
              <div
                className={`hidden md:block mt-3 rounded-2xl ${isHeaderFilterEmptyState ? "" : "scroll-inner max-h-[calc(100vh-250px)] overscroll-y-contain pb-20"
                  } ${isRxOrders ? "min-h-[320px]" : ""}`}
              >
                <table
                  className={`w-full ${isHeaderFilterEmptyState ? "min-w-full" : isRxOrders ? "min-w-full" : "min-w-[1700px]"} border-separate border-spacing-x-0 border-spacing-y-0.5 bg-[#F5F5F5] rounded-xl px-[3px] pb-[1px]`}
                >
                  <thead className="bg-[#F5F5F5] text-[#1F1F23] text-xs sticky top-0 z-[30]">
                    <tr>
                      {isCentralModule && (
                        <th scope="col" className={headerClass}>
                          Order ID
                        </th>
                      )}
                      {showNonRxOrderColumns && (
                        <th scope="col" className={headerClass}>
                          {isCentralOpsUser ? (
                            orderType === "QC" ? (
                              <SearchableSelectMenu
                                onSelectItem={(items) => {
                                  if (items) {
                                    applyImmediateFilterChange("codStatus", items.id, {
                                      shouldDirty: true,
                                      shouldTouch: true,
                                      shouldValidate: true,
                                    });
                                  }
                                }}
                                asButton
                                renderAsButton={
                                  <button type="button" className="flex items-center gap-1 text-xs">
                                    Suborder ID
                                    <GrFormFilter className="h-4 w-4" />
                                  </button>
                                }
                                register={formHook.register("codStatus")}
                                defaultSelectId={codStatus}
                                selectItems={qcSuborderFilterList}
                                fieldError={formHook.formState.errors.codStatus}
                                errorMessages={[]}
                              />
                            ) : (
                              <span>Suborder ID</span>
                            )
                          ) : (
                            <SearchableSelectMenu
                              onSelectItem={(items) => {
                                if (items) {
                                  applyImmediateFilterChange("codStatus", items.id, {
                                    shouldDirty: true,
                                    shouldTouch: true,
                                    shouldValidate: true,
                                  });
                                }
                              }}
                              asButton
                              renderAsButton={
                                <button type="button" className="flex items-center gap-1">
                                  Suborder ID
                                  <GrFormFilter className="h-4 w-4" />
                                </button>
                              }
                              register={formHook.register("codStatus")}
                              defaultSelectId={codStatus}
                              selectItems={CODLIST}
                              fieldError={formHook.formState.errors.codStatus}
                              errorMessages={[]}
                            />
                          )}
                        </th>
                      )}
                      {isCentralModule && showNonRxOrderColumns && (
                        <th scope="col" className={headerClass}>
                          Clinic Name
                        </th>
                      )}
                      {isCentralModule && (
                        <th scope="col" className={headerClass}>
                          <SearchableSelectMenu
                            onSelectItem={(items) => {
                              if (items) {
                                applyImmediateFilterChange("breach", items.id, {
                                  shouldDirty: true,
                                });
                              }
                            }}
                            asButton
                            renderAsButton={
                              <button type="button" className="flex items-center gap-1">
                                Client Details
                                <GrFormFilter className="h-4 w-4" />
                              </button>
                            }
                            register={formHook.register("breach")}
                            defaultSelectId={breach}
                            selectItems={BREACHLIST}
                            fieldError={formHook.formState.errors.breach}
                            errorMessages={[]}
                          />
                        </th>
                      )}
                      {isClinicModule && (
                        <th scope="col" className={headerClass}>
                          <SearchableSelectMenu
                            onSelectItem={(items) => {
                              if (items) {
                                applyImmediateFilterChange("breach", items.id, {
                                  shouldDirty: true,
                                });
                              }
                            }}
                            asButton
                            renderAsButton={
                              <button type="button" className="flex items-center gap-1">
                                Client Details
                                <GrFormFilter className="h-4 w-4" />
                              </button>
                            }
                            register={formHook.register("breach")}
                            defaultSelectId={breach}
                            selectItems={BREACHCLINICLIST}
                            fieldError={formHook.formState.errors.breach}
                            errorMessages={[]}
                          />
                        </th>
                      )}
                      {isRxOrders && (
                        <th scope="col" className={headerClass}>
                          <SearchableSelectMenu
                            onSelectItem={(item) => {
                              if (item) {
                                formHook.setValue("rxCallDetails", item.id);
                              }
                            }}
                            asButton
                            renderAsButton={
                              <button
                                type="button"
                                className="flex items-center gap-1 text-xs font-medium text-[#1F1F23]"
                              >
                                Call Details
                                <GrFormFilter className="h-4 w-4" />
                              </button>
                            }
                            register={formHook.register("rxCallDetails")}
                            defaultSelectId={rxCallDetails}
                            selectItems={RX_CALL_DETAILS_FILTER_OPTIONS}
                            fieldError={formHook.formState.errors.rxCallDetails}
                            errorMessages={[]}
                            listBoxClassName="top-full mt-1 w-44 max-h-40 overflow-y-auto"
                            listZIndex="z-[120]"
                          />
                        </th>
                      )}
                      {showDeliveryAddressColumn && (
                        <th scope="col" className={`${headerClass} min-w-[220px]`}>
                          Delivery Address
                        </th>
                      )}
                      <th scope="col" className={`${headerClass} ${isRxOrders ? "min-w-[220px]" : "min-w-[260px]"}`}>
                        Items
                      </th>
                      <th scope="col" className={headerClass}>
                        <span>Order Status</span>
                      </th>
                      {showNonRxOrderColumns && (
                        <th scope="col" className={headerClass}>
                          <SearchableSelectMenu
                            onSelectItem={(items) => {
                              if (items) {
                                applyImmediateFilterChange("rider", items.id, {
                                  shouldDirty: true,
                                });
                              }
                            }}
                            asButton
                            renderAsButton={
                              <button type="button" className="flex items-center gap-1">
                                Rider Details
                                <GrFormFilter className="h-4 w-4" />
                              </button>
                            }
                            register={formHook.register("rider")}
                            defaultSelectId={rider}
                            selectItems={RIDERLIST}
                            fieldError={formHook.formState.errors.rider}
                            errorMessages={[]}
                          />
                        </th>
                      )}
                      {showNonRxOrderColumns && (
                        <th scope="col" className={`${headerClass} min-w-[160px]`}>
                          Invoice
                        </th>
                      )}
                      <th scope="col" className={`${headerClass} ${actionStickyHeaderClass}`}>
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-xs">
                    {hasVisibleRows ? (
                      currentTableData?.map((order, id) => {
                        const isSingle = currentTableData.length === 1;
                        const isFirst = id === 0;
                        const isLast = id === currentTableData.length - 1;
                        const slaTags = getSlaTags(order?.order_details?.sla_tags);
                        return (
                          <tr key={id} className="group bg-white">
                            {isCentralModule && (
                              <td
                                className={`${cellClass} whitespace-nowrap ${isSingle
                                  ? "rounded-tl-2xl rounded-bl-2xl"
                                  : isFirst
                                    ? "rounded-tl-2xl"
                                    : isLast
                                      ? "rounded-bl-2xl"
                                      : ""
                                  }`}
                              >
                                <p>{order?.order_details?.order_id}</p>
                                {isRxOrders && (
                                  <div className="text-[11px] text-gray-500">{veticDateFormat(order?.created_at)}</div>
                                )}
                                {order?.source === "kuddle" && (
                                  <span className="mt-1 inline-flex rounded-full bg-[#0D9488] px-2 py-0.5 text-[11px] font-semibold text-white">
                                    Kuddle
                                  </span>
                                )}
                              </td>
                            )}
                            {showNonRxOrderColumns && (
                              <td className={`${cellClass} whitespace-nowrap`}>
                                <div className="mb-1 flex flex-wrap gap-1">{renderOrderMetaBadges(order)}</div>
                                <div className="font-medium">
                                  {formatSubOrderId(order?.order_details?.sub_order_id)}
                                </div>
                                <div className="text-[11px] text-gray-500">{veticDateFormat(order?.created_at)}</div>
                                {order?.order_details?.is_partial_handling_needed === true && isCentralModule && (
                                  <ViewPartialDetails orders={order} />
                                )}
                              </td>
                            )}
                            {isCentralModule && showNonRxOrderColumns && (
                              <td
                                className={`${cellClass}`}
                              >
                                <div className="flex flex-col gap-0.5 max-w-[120px]">
                                  {hasClinicName(order?.clinic_details?.name) &&
                                    <p className="text-xs text-gray-500 break-words whitespace-normal leading-tight">{order?.clinic_details?.name}</p>
                                  }
                                </div>
                              </td>
                            )}
                            <td className={cellClass}>
                              <div className="flex flex-col gap-1">
                                <div className="flex items-center gap-2">
                                  <span
                                    onClick={() => {
                                      if (order?.source !== "C2C") {
                                        visitCustomerProfile(order?.client_details?.user_id);
                                      }
                                    }}
                                    data-tooltip-id="order_client_name"
                                    data-tooltip-content={order?.client_details?.name}
                                    className={`text-xs capitalize ${order?.source === "C2C" ? "text-gray-900" : "cursor-pointer text-[#0B6EFF]"}`}
                                  >
                                    {truncateString(order?.client_details?.name, 15)}
                                  </span>
                                  {renderRxCallButton(order)}
                                </div>
                                {isCentralModule && (
                                  <div>{maskMobile(String(order?.client_details?.mobile ?? "")) || "NA"}</div>
                                )}
                                {slaTags?.length > 0 && (
                                  <div className="mt-1 flex flex-wrap gap-1">
                                    {slaTags?.map((tag) => (
                                      <span
                                        key={`${order?.order_details?.sub_order_id}-${tag}`}
                                        className={`inline-flex w-fit whitespace-nowrap rounded-full px-2 py-0.5 text-[10px] font-semibold ring-1 ring-inset ${getSlaTagClass(tag)}`}
                                      >
                                        {toTitleCase(tag)}
                                      </span>
                                    ))}
                                  </div>
                                )}
                                {(order?.refund_details || order?.refund_history?.length > 0) && isCentralModule && (
                                  <ViewRefundDetails orders={order} />
                                )}
                              </div>
                            </td>
                            {isRxOrders && (
                              <td className={cellClass}>
                                {(() => {
                                  const rxCallDetails = getRxCallDetails(order);
                                  return (
                                    <div className="w-[180px] flex flex-col gap-1 text-[11px] text-gray-800">
                                      <p>
                                        <span className="font-semibold text-gray-500">Total Attempts:</span>{" "}
                                        {String(rxCallDetails.doctorTriedToConnect)}
                                      </p>
                                      <p>
                                        <span className="font-semibold text-gray-500">Last Tried:</span>{" "}
                                        {rxCallDetails.lastTriedAt}
                                      </p>
                                      {rxCallDetails.customer_tried && (
                                        <p>
                                          <span className="inline-flex rounded-full bg-[#FEF3F2] px-2 py-0.5 text-[10px] font-semibold text-[#B42318] ring-1 ring-inset ring-[#FDA29B]">
                                            Customer Tried
                                          </span>
                                        </p>
                                      )}
                                    </div>
                                  );
                                })()}
                              </td>
                            )}
                            {showDeliveryAddressColumn && (
                              <td className={cellClass}>
                                <div className="w-[260px] break-words">
                                  <span className="flex items-start gap-1">
                                    <span>{order?.client_details?.address_detail?.address_1}</span>
                                    <ClipboardComponent
                                      className="h-4 w-4 opacity-0 transition-opacity duration-150 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto"
                                      copyId="order"
                                      tooltipText="Copy lat long"
                                      text={`latitude: ${order?.client_details?.address_detail?.latitude} longitude: ${order?.client_details?.address_detail?.longitude}`}
                                    />
                                  </span>
                                </div>
                                <div className="mt-1">{order?.client_details?.address_detail?.address_2}</div>
                              </td>
                            )}
                            <td className={cellClass}>
                              {order?.order_details?.order_status === "confirmed" && orderModule === "CLINIC" ? null : (
                                <ol className="m-0 space-y-1 p-0">
                                  {order?.order_details?.sub_order_items?.map((item, itemId) => (
                                    <li key={itemId} className="flex">
                                      <div className="flex w-full max-w-[320px] cursor-pointer break-words">
                                        {itemId + 1}.
                                        <span>
                                          <ProductItemImage value={item} data={order.order_details.sub_order_items} />
                                        </span>
                                      </div>
                                    </li>
                                  ))}
                                </ol>
                              )}
                            </td>
                            <td className={`${cellClass} whitespace-nowrap`}>
                              <div className="flex flex-col gap-1">
                                <div className="flex items-center gap-2">
                                  <div className="flex flex-col gap-1">
                                    <OrderStatus status={order?.order_details?.order_status} />
                                  </div>
                                  {showNonRxOrderColumns && (
                                    <span
                                      className="inline-flex opacity-0 transition-opacity duration-150 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto"
                                      onClick={() => setOrdertrails(order?.delivery_trail)}
                                    >
                                      <MdInfoOutline className="h-4 w-4 cursor-pointer text-gray-500 hover:text-gray-700" />
                                    </span>
                                  )}
                                </div>
                                {(order?.order_details?.rx_uploaded || order?.rx_uploaded) && (
                                  <button
                                    type="button"
                                    onClick={() => handleViewUploadedPrescription(order)}
                                    disabled={rxUploadInProgressMap[order?.order_details?.sub_order_id || order?.order_details?.order_id]}
                                    className="flex items-center gap-1 text-xs font-medium text-[#0B6EFF] hover:underline disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
                                  >
                                    <span>{rxUploadInProgressMap[order?.order_details?.sub_order_id || order?.order_details?.order_id] ? "Opening..." : "Uploaded RX"}</span>
                                    <FiFileText className="h-3.5 w-3.5" />
                                  </button>
                                )}
                              </div>
                            </td>
                            {showNonRxOrderColumns && (
                              <td className={cellClass}>
                                <div className="w-[210px] rounded-lg bg-[#F9FAFB] p-2">
                                  <p className="text-xs font-semibold text-gray-900">
                                    {order?.delivery_details?.rider_name}
                                  </p>
                                  <p className="mt-0.5 text-xs text-gray-700">
                                    {order?.delivery_details?.rider_mobile}
                                  </p>
                                  <p className="mt-1 text-[11px] text-gray-600">
                                    {order?.delivery_details?.expected_time ? (
                                      <span>
                                        {" "}
                                        ETA: {convertStringToDate(order?.delivery_details?.expected_time, "time")}
                                      </span>
                                    ) : (
                                      <span>ETA:NA</span>
                                    )}
                                  </p>
                                  {order?.order_details?.order_status !== "confirmed" &&
                                    order?.delivery_details?.tracking_link && (
                                      <p
                                        className="mt-1 inline-flex cursor-pointer rounded-full bg-[#EEF4FF] px-2 py-0.5 text-[11px] font-medium text-[#0B6EFF] hover:bg-[#DFEAFF]"
                                        onClick={() => window.open(order?.delivery_details?.tracking_link, "_blank")}
                                      >
                                        Tracking Link
                                      </p>
                                    )}
                                  <div className="mt-2 flex flex-wrap gap-1">
                                    {order?.delivery_details?.drop_otp && !hideDropOtp && (
                                      <span className="rounded-full bg-[#F3F4F6] px-2 py-0.5 text-[10px] text-gray-700">
                                        Drop: {order.delivery_details.drop_otp}
                                      </span>
                                    )}
                                    {order?.delivery_details?.pickup_otp &&
                                      order?.order_details?.order_status === "ready_for_pickup" && (
                                        <span className="rounded-full bg-[#F3F4F6] px-2 py-0.5 text-[10px] text-gray-700">
                                          Pickup: {order?.delivery_details?.pickup_otp}
                                        </span>
                                      )}

                                    {order?.delivery_details?.rto_otp && (
                                      <span className="rounded-full bg-[#F3F4F6] px-2 py-0.5 text-[10px] text-gray-700">
                                        RTO: {order?.delivery_details?.rto_otp}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </td>
                            )}
                            {showNonRxOrderColumns && (
                              <td className={`${cellClass} pr-3`}>
                                {order?.order_details?.order_status === "confirmed" &&
                                  orderModule === "CLINIC" ? null : order?.invoice_details?.length > 0 ? (
                                    <div className="flex flex-col gap-1">
                                      {order?.invoice_details?.map((invoice, index) => (
                                        <a
                                          key={index}
                                          href={invoice?.invoice_link}
                                          target="_blank"
                                          rel="noreferrer"
                                          className="flex items-center gap-2 text-[#0B6EFF] hover:underline"
                                        >
                                          <span className="text-xs break-all">{invoice?.file_name}</span>
                                          <img
                                            className="shrink-0"
                                            src="https://vetic-img.s3.ap-south-1.amazonaws.com/website/admin-tool/invoiceIcon.svg"
                                            alt="invoice"
                                          />
                                        </a>
                                      ))}
                                    </div>
                                  ) : (
                                  <span>NA</span>
                                )}
                              </td>
                            )}
                            <td
                              className={`${cellClass} ${actionStickyCellClass} ${isSingle
                                ? "rounded-tr-2xl rounded-br-2xl"
                                : isFirst
                                  ? "rounded-tr-2xl"
                                  : isLast
                                    ? "rounded-br-2xl"
                                    : ""
                                }`}
                              style={{ zIndex: Math.max(1, 20 - id) }}
                            >
                              <div className={isCentralModule ? "min-w-[170px]" : "min-w-[140px]"}>
                                <OrderActionButton orders={order} module={orderModule} />
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="bg-white">
                        <td colSpan={emptyStateColSpan} className="rounded-b-2xl p-4">
                          <div className="mx-auto max-w-[460px]">
                            <NoDataFoundComponent imageURL={NO_PWL_RESULTS} message="No Orders Found" />
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <NoDataFoundComponent imageURL={NO_PWL_RESULTS} message="No Orders Found" />
          )}
          {hasVisibleRows && (
            <div className="mt-2 border-t border-gray-100 bg-white px-2 py-3 md:sticky md:bottom-0 md:left-0 md:z-20">
              <div className="flex justify-center md:justify-end">
                <PaginationComponent
                  className="pagination-bar !float-none"
                  currentPage={currentPage}
                  totalCount={Math.max(totalOrders || 0, currentTableData?.length || 0)}
                  pageSize={PageSize}
                  onPageChange={(pageNumber) => {
                    setCurrentPage(pageNumber);
                    fetchOrdersForPage(pageNumber);
                  }}
                />
              </div>
            </div>
          )}
          <Tooltip id="order_client_name" place="bottom" />
          <Tooltip id="order_clinic_name" place="bottom" />
          {ordertrails && <OrderTrailsComponent ordertrails={ordertrails} setOrdertrails={setOrdertrails} />}
        </div>
      ) : (
        <TableSkeleton />
      )}
    </div>
  );
};

export default CentralOrderComponent;
